
import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    scheduleDays: [],
    adjacentScheduleDays: {},
    loading: false,
  }),
  mutations: {
    setScheduleDays(state, payload) {
      state.scheduleDays = payload
    },
    setAdjacentScheduleDays(state, payload) {
      state.adjacentScheduleDays = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async fetchScheduleDays(context, { id, date_from, date_to, team_ids }) {
      withLoading(async () => {
        const params = { date_from, date_to, team_ids, }
        const response = await api.get(`schedules/${id}/schedule_days`, { params })
        context.commit("setScheduleDays", response.data)
      }, context)
    },

    async fetchAdjacentScheduleDays(context, { id, date_from, date_to, team_ids }) {
      withLoading(async () => {
        const params = { date_from, date_to, team_ids, }
        const response = await api.get(`schedules/${id}/schedule_days/adjacent`, { params })
        context.commit("setAdjacentScheduleDays", response.data)
      }, context)
    },
  }
}